export function hav(lat1,lon1,lat2,lon2){
  const R=6371,dLat=(lat2-lat1)*Math.PI/180,dLon=(lon2-lon1)*Math.PI/180;
  const a=Math.pow(Math.sin(dLat/2),2)+Math.cos(lat1*Math.PI/180)*Math.cos(lat2*Math.PI/180)*Math.pow(Math.sin(dLon/2),2);
  return R*2*Math.atan2(Math.sqrt(a),Math.sqrt(1-a));
}

export function makeCircle(lng,lat,r){
  const pts=64,coords=[];
  for(let i=0;i<pts;i++){
    const a=(i/pts)*2*Math.PI;
    const dx=r/(111.32*Math.cos(lat*Math.PI/180));
    const dy=r/110.574;
    coords.push([lng+dx*Math.cos(a),lat+dy*Math.sin(a)]);
  }
  coords.push(coords[0]);
  return {type:'Feature',geometry:{type:'Polygon',coordinates:[coords]}};
}
